import { Form, Pane } from "components/materials";
import { formatCurrency } from "helpers/formatCurrency";
import unformatNumber from "helpers/unformatNumber";
import { majorScale } from "helpers/utilities";
import { COMPARATORS, getColumnHeaderText } from "../FastDataTableUtils";

const options = [
  COMPARATORS.GREATER_THAN,
  COMPARATORS.LESS_THAN,
  COMPARATORS.EQUAL,
  COMPARATORS.NOT_EQUAL,
];

export const currencyColumnDefaults = {
  aggregate: () => null,
  aggregateFormatter: (value) =>
    value === undefined || value === null ? "-" : formatCurrency(value),
  filterControl: (index) => (
    <Pane display="flex">
      <Form.Select name={`filters.${index}.operator`} options={options} />
      <Form.Input
        name={`filters.${index}.input`}
        type="currency"
        marginLeft={majorScale(1)}
      />
    </Pane>
  ),
  filterFormatter: (fc, column) =>
    `${getColumnHeaderText(column)}: ${COMPARATORS[fc.operator].text} ${
      fc.input
    }`,
  filterStrategy: (value, fc) => {
    const lhs = value;
    const rhs = unformatNumber(fc.input);
    switch (fc.operator) {
      case COMPARATORS.GREATER_THAN.value:
        return lhs > rhs;
      case COMPARATORS.LESS_THAN.value:
        return lhs < rhs;
      case COMPARATORS.EQUAL.value:
        return lhs === rhs;
      case COMPARATORS.NOT_EQUAL.value:
        return lhs !== rhs;
      default:
        return true;
    }
  },
  sortStrategy: (valueA, valueB) => valueA - valueB,
  textAlign: "right",
  type: "currency",
  valueFormatter: (value) =>
    value === undefined || value === null ? null : formatCurrency(value),
  width: 120,
};
